<template>
  <div>
    <v-layout
      row
      align-center
      :style="myLayoutStyle"
    >
      <v-flex
        xs12
        sm10
        offset-sm1
        md10
        offset-md1
        lg10
        offset-lg1
        xl8
        offset-xl2
      >
        <v-card
          flat
          :color="theme.bg_color"
        >
          <v-card-text>
            <v-layout
              row
              align-center
            >
              <page-title :title="$t('my_address')" />
            </v-layout>
            <div v-if="addresses && addresses.length > 0">
              <v-card
                v-for="address in addresses"
                :key="address.id"
                style="border-radius: 5px; margin-bottom: 18px;"
                :color="theme.address_bg_color"
              >
                <v-card-title class="pb-0">
                  <v-layout row>
                    <v-flex xs8>
                      <h4 :style="cardTitleStyle">{{ !address.title ? 'Saved address' : address.title }}</h4>
                    </v-flex>
                    <v-flex
                      xs4
                      text-xs-right
                    >
                      <div style="margin-top: -9px;">
                        <v-btn
                          icon
                          small
                        >
                          <v-icon
                            small
                            :color="theme.address_text_color"
                            @click="deleteAddress(address.id)"
                          >fa-trash-alt</v-icon>
                        </v-btn>
                        <v-btn
                          icon
                          small
                        >
                          <v-icon
                            small
                            :color="theme.address_text_color"
                            @click="editAddress(address)"
                          >fas fa-edit</v-icon>
                        </v-btn>
                      </div>
                    </v-flex>
                  </v-layout>
                </v-card-title>
                <v-card-text :style="cardTextStyle">
                  {{ fullAddress(address) }}
                  <v-checkbox
                    v-model="address.default"
                    :color="theme.btn_color_secondary"
                    class="default-checkbox"
                    :dark="dark"
                    @click="setDefaultAddress(address.id)"
                  >
                    <template slot="label">
                      <span :style="cardTextStyle">Default address</span>
                    </template>
                  </v-checkbox>
                </v-card-text>
              </v-card>
            </div>
            <div
              v-else
              class="mt-2 mb-2"
              :style="nameStyle"
            >
              {{ $t('none') }}
            </div>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
    <v-footer
      v-if="addresses && addresses.length < 5"
      fixed
      app
      inset
      :height="theme.footer_height"
      :color="theme.footer_bg_color"
    >
      <v-btn
        block
        dark
        large
        class="btn"
        :color="theme.btn_color_primary"
      >
        <v-layout row>
          <v-flex
            xs12
            class="text-xs-center"
            @click="addAddress"
          >
            {{ $t('add') }}
          </v-flex>
        </v-layout>
      </v-btn>
    </v-footer>
    <v-dialog
      v-model="dialog"
      persistent
      fullscreen
    >
      <v-card :color="theme.login_bg_color">
        <v-card-text class="pa-4">
          <v-layout row>
            <v-flex
              xs12
              sm10
              offset-sm1
              md8
              offset-md2
              lg6
              offset-lg3
              xl6
              offset-xl3
            >
              <v-layout
                row
                align-center
              >
                <v-flex xs12>
                  <span class="main-title">{{ dialogAddressId ? $t('edit_address') : $t('add_address') }}</span>
                </v-flex>
              </v-layout>
              <div class="mt-3">
                <div
                  class="mr-2 text-xs-center"
                  :style="labelStyle('Home')"
                  @click="inputAddress.title = 'Home'"
                >
                  <v-icon
                    class="middle"
                    small
                    color="#515152"
                  >fas fa-home</v-icon>
                  <span class="middle">Home</span>
                </div>
                <div
                  class="mr-2 text-xs-center"
                  :style="labelStyle('Office')"
                  @click="inputAddress.title = 'Office'"
                >
                  <v-icon
                    class="middle"
                    small
                    color="#515152"
                  >fas fa-building</v-icon>
                  <span class="middle">Office</span>
                </div>
              </div>
              <div class="mt-3 mb-0">
                <v-text-field
                  v-model="inputAddress.postal_code"
                  outline
                  ref="postalCodeField"
                  name="postalCode"
                  label="Postal code"
                  @keyup="checkAddress"
                  hide-details
                ></v-text-field>
                <v-text-field
                  v-model="inputAddress.block_no"
                  outline
                  :style="inputAddressStyle"
                  clearable
                  ref="blockNoField"
                  name="blockNo"
                  label="Block no."
                  hide-details
                ></v-text-field>
                <v-text-field
                  v-model="inputAddress.road_name"
                  outline
                  :style="inputAddressStyle"
                  clearable
                  ref="roadNameField"
                  name="roadName"
                  label="Road name"
                  hide-details
                ></v-text-field>
                <v-text-field
                  v-model="inputAddress.building"
                  outline
                  :style="inputAddressStyle"
                  clearable
                  ref="buildingField"
                  name="building"
                  label="Building (optional)"
                  hide-details
                ></v-text-field>
                <v-text-field
                  v-model="inputAddress.floor_unit"
                  outline
                  :style="inputAddressStyle"
                  clearable
                  ref="floorUnitField"
                  name="floorUnit"
                  label="Floor unit"
                  hide-details
                ></v-text-field>
                <v-text-field
                  v-model="inputAddress.contact_name"
                  outline
                  :style="inputAddressStyle"
                  clearable
                  ref="contactNameField"
                  name="contactName"
                  label="Recipient Name (optional)"
                  hide-details
                ></v-text-field>
                <v-text-field
                  v-model="inputAddress.contact_no"
                  outline
                  :style="inputAddressStyle"
                  clearable
                  ref="contactNoField"
                  name="contactNo"
                  label="Contact No. (optional)"
                  type="number"
                  maxlength="8"
                  :rules="inputAddress.contact_no ? [phoneRules.pattern] : []"
                >
                  <v-card-text
                    slot="prepend-inner"
                    style="padding: 14px 0 0 0"
                  >
                    +65
                  </v-card-text>
                </v-text-field>
              </div>
              <div class="text-xs-center">
                <v-btn
                  :dark="enableBtn"
                  :color="theme.btn_color_secondary"
                  :disabled="!enableBtn"
                  @click="saveAddress"
                >
                  {{ $t('save') }}
                </v-btn>
                <v-btn
                  flat
                  :color="theme.btn_color_secondary"
                  @click="dialog = false"
                >
                  {{ $t('close') }}
                </v-btn>
              </div>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from 'axios'
import { mapGetters } from 'vuex'
import PageTitle from '~/components/PageTitle'

export default {
  name: 'addresses-view',
  metaInfo () {
    return { title: "Addresses" }
  },
  components: {
    'page-title': PageTitle
  },
  data: () => ({
    dialog: false,
    dialogAddressId: null,
    enableBtn: true,
    inputAddress: {
      title: '',
      postal_code: '',
      floor_unit: '',
      block_no: '',
      road_name: '',
      building: '',
      country: 'SINGAPORE',
      contact_name: '',
      contact_no: ''
    },
    phoneRules: {
      pattern: value => {
        const pattern = /^$|^[8,9,3].{7}$/
        return pattern.test(value) || 'Invalid phone number.'
      },
    },
  }),
  computed: {
    ...mapGetters('config', [
      'theme'
    ]),
    ...mapGetters('auth',[
      'authMsg', 'addresses'
    ]),
    dark () {
      return parseInt(this.theme.address_theme) === 1
    },
    myLayoutStyle () {
      return {
        marginLeft: '-8px',
        marginRight: '-8px',
        marginBottom: '-16px',
        backgroundColor: this.theme.bg_color
      }
    },
    nameStyle () {
      return {
        color: this.theme.orders_name_color
      }
    },
    cardTitleStyle () {
      return {
        color: this.theme.address_text_color,
        fontWeight: 800,
        textTransform: 'capitalize'
      }
    },
    cardTextStyle () {
      return {
        paddingTop: '0',
        color: this.theme.address_text_color
      }
    },
    inputAddressStyle () {
      return {
        marginTop: '10px',
        color: this.theme.cart_name_color,
      }
    },
  },
  methods: {
    fullAddress (address) {
      return (address.block_no ? address.block_no + ' ' : '')
          + (address.road_name ? address.road_name + ' ' : '')
          + (address.building ? address.building + ' ' : '')
          + (address.floor_unit && address.floor_unit !== '-' ? address.floor_unit + ' ' : '')
          + (address.postal_code ? address.postal_code + ' ' : '')
          + (address.country ? address.country : '')
    },
    labelStyle (type) {
      let styles = {
        border: '1px solid #515152',
        padding: '5px',
        display: 'inline-block',
        borderRadius: '7px',
        color: '#515152',
      }
      if (this.inputAddress.title === type) {
        styles.background = '#ffebeb'
      }
      return styles
    },
    async checkAddress () {
      this.enableBtn = false
      if (this.inputAddress.postal_code.length === 6) {
        this.$bus.$emit('showFullLoading', true)
        const { data } = await axios.post('/api/location', {
          postal_code :  this.inputAddress.postal_code
        })
        if (data.code === 1) {
          this.enableBtn = true
          const location = data.location
          this.inputAddress.block_no = location.BLK_NO ? location.BLK_NO : ''
          this.inputAddress.road_name = location.ROAD_NAME ? location.ROAD_NAME : ''
          this.inputAddress.building = location.BUILDING ? location.BUILDING : ''
        }
        this.$bus.$emit('showFullLoading', false)
      }
    },
    editAddress (address) {
      this.enableBtn = true
      this.dialogAddressId = address.id
      this.inputAddress = {
        title: address.title,
        postal_code: address.postal_code,
        floor_unit: address.floor_unit,
        block_no: address.block_no,
        road_name: address.road_name,
        building: address.building,
        country: 'SINGAPORE',
        contact_name: address.contact_name,
        contact_no: address.contact_no
      }
      this.dialog = true
    },
    addAddress () {
      this.enableBtn = false
      this.dialogAddressId = null
      this.inputAddress = {
        title: 'Home',
        postal_code: '',
        floor_unit: '',
        block_no: '',
        road_name: '',
        building: '',
        country: 'SINGAPORE',
        contactName: '',
        contactNo: '',
      }
      this.dialog = true
    },
    async saveAddress () {
      this.$bus.$emit('showFullLoading', true)
      if (!this.dialogAddressId) {
        await this.$store.dispatch('auth/addAddress', this.inputAddress)
      } else {
        await this.$store.dispatch('auth/editAddress', { id: this.dialogAddressId, ...this.inputAddress })
      }
      this.$bus.$emit('showFullLoading', false)
      if (this.authMsg) {
        this.$store.dispatch('responseMessage', {
          type: 'error',
          title: this.$t('address_saved_title'),
          text: this.$t(this.authMsg),
          modal: true
        })
      } else {
        this.dialog = false
        this.$store.dispatch('responseMessage', {
          type: 'success',
          text: this.$t('address_saved_success_notice')
        })
      }
    },
    async setDefaultAddress (id) {
      this.$bus.$emit('showFullLoading', true)
      await this.$store.dispatch('auth/setDefaultAddress', id)
      this.$bus.$emit('showFullLoading', false)
    },
    deleteAddress (id) {
      this.$store.dispatch('responseMessage', {
        type: 'error',
        title: this.$t('address_saved_title'),
        text: this.$t('address_deleted_confirmation'),
        btn3: { text: 'Ok', function: 'deleteAddress2', param: id },
        modal: true
      })
    },
    async deleteAddress2 (id) {
      this.$bus.$emit('showFullLoading', true)
      await this.$store.dispatch('auth/deleteAddress', id)
      this.$bus.$emit('showFullLoading', false)
      if (this.authMsg) {
        this.$store.dispatch('responseMessage', {
          type: 'error',
          title: this.$t('address_saved_title'),
          text: this.$t('address_deleted_fail_notice'),
          modal: true
        })
      } else {
        this.$store.dispatch('responseMessage', {
          type: 'success',
          text: this.$t('address_deleted_success_notice')
        })
      }
    }
  },
  beforeMount () {
    const vm = this
    this.$bus.$on('deleteAddress2', (payload) => {
      vm.deleteAddress2(payload)
    })
  },
  async created () {
    this.$bus.$emit('showFullLoading', true)
    await this.$store.dispatch('auth/fetchAddresses')
    this.$bus.$emit('showFullLoading', false)
  },
  beforeDestroy () {
    this.$bus.$off('deleteAddress2')
  }
}
</script>

<style scoped>
.main-title {
  font-weight: 800;
}
.btn {
  margin: 10px;
  padding: 0 16px;
}
.default-checkbox {
  margin-top: 5px;
  margin-bottom: -25px;
}
.middle {
  padding: 2px;
}
</style>



// WEBPACK FOOTER //
// src/pages/addresses.vue